import { css } from '@emotion/css'
import { styled } from '@mui/material'
import { COLORS } from 'src/styles/common'


export const FooterSt = styled('div')<{
  primaryColor?: string
}>(({ theme, primaryColor }) => ({
  display: 'flex',
  ustifyContent: 'flex-end',
  backgroundColor: primaryColor || COLORS.PRIMARY,
  padding: '5px 30px',
  marginTop: 'auto',

  [theme.breakpoints.down('md')]: {
    padding: '5px 14px',
  },
}))

export const ContentSt = styled('div')`
  width: 100%;
  /* height: 100%; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`

export const versionSt = css`
  display: inline-flex;
  margin-left: auto;
`
